import React  from "react";
import moment from 'moment';
import classNames from 'classnames';

import { Link } from "react-router-dom";
import Network from "~/services/networks";
import validator from 'validator';


const NetworkCard = ({item, user, checkLimitedNetwork, booster})=> {

  const placeholders = {
    '{userid}' : user.id
  };

  const makePath = (path) => {
    return Object.keys(placeholders).reduce((memo, item)=> (
      memo = memo.replace(item, placeholders[item])
    ), path);
  };

  const testing = item.status === Network.status.TESTING;
  const limited = item.limitPoints > user.totalPoints || item.usersPaymentLimit > user.acceptedCashouts || item.daysLimit > moment().diff(moment(user.createdAt), 'days');

  return (
    <Link className={classNames("network-item", {testing, limited} )}
      onClick={()=> checkLimitedNetwork(item)}
      target={validator.isURL(item.path.toString()) ? '_blank' : '_self' }
      to={ {pathname: (
        (!item.limitPoints       || item.limitPoints       <= user.totalPoints) &&
        (!item.daysLimit         || item.daysLimit         <= moment().diff(moment(user.createdAt), 'days')) &&
        (!item.usersPaymentLimit || item.usersPaymentLimit <= user.acceptedCashouts)
      ) ? makePath(item.path) : '/offers'}}
    >
      <div> <img src={item.icon} style={{ width: item.iconWidth || 50 }} /> </div>

      <div className="network-title mb-2">
        <h6 className="mb-0"> {item.name} </h6>
          {(item.daysLimit && item.daysLimit > moment().diff(moment(user.createdAt), 'days')) ? <small> Your account must be al least {item.daysLimit} days old!</small> : null}
          {(item.usersPaymentLimit && item.usersPaymentLimit > user.acceptedCashouts) ? <small>{item.usersPaymentLimit} accepted cashouts are required!</small> : null}
          {(item.limitPoints && item.limitPoints > user.totalPoints) ? <small>{item.limitPoints} points are required!</small> : null}
      </div>

      {booster && !limited &&!testing && (<div className="boosted">+{booster.percentage}% Points</div>)}

    </Link>
  );
};

export default NetworkCard;
